import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './components/App/App';
import './google-analytics';
import { configureStore } from './store';

import $ from 'jquery';
import { TimelineMax, TweenMax, RoughEase, Power0, Power2} from 'gsap';

// Initialize store
const store = configureStore();
const mountApp = document.getElementById('root');

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  mountApp
);

$(window).on('load', function() {
    // hide loading screen on page load
    window.TweenMax.to('.js-curtain-loading', 0.8, {
        // delay: 9,
        delay: 1,
        y: '-100%',
        ease: window.Power2.easeInOut,
        onComplete: function() {
            // $('.js-curtain-loading').addClass('curtain--hidden');
        }
    });
    window.TweenMax.to('.js-lighting-mask', 1, {
        // delay: 9.2,
        delay: 1.2,
        autoAlpha: 0,
        onComplete: function() {
            $('.js-lighting-mask').addClass('hidden');
        }
    });
});



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/